import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocV1UserInfo extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_USERINFO)
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">User Information</h3>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_USERINFO}
                </code>
                <div className="description">
                    Returns user level information about the user with the associated authorization key.<br/>
                </div>

                <h4 className="heading-2">Response</h4>
                <div className="description">
                    The following table describes the results of the userinfo response:
                </div>
                <h4 className="heading-3" id="uiv1_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">accountEnabled</td>
                        <td className="meaning">Enabled or disabled status of the user account.
                        </td>
                        <td className="type">Boolean</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">createDate</td>
                        <td className="meaning">Date the user account was created.
                        </td>
                        <td className="type">Date/Time</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">expirationDate</td>
                        <td className="meaning">Date the user account will expire.
                        </td>
                        <td className="type">Date/Time</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">User login identifier.
                        </td>
                        <td className="type">String</td>
                        <td className="type">This is usually the user's email address.</td>
                    </tr>
                    <tr>
                        <td className="attribute">actualIntervalRequests</td>
                        <td className="meaning">The number of requests made for the current time window.
                        </td>
                        <td className="type">Positive Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">intervalSecondsRemaining</td>
                        <td className="meaning">The remaining time (in seconds) before the rate limit resets and requests will be accepted again.
                        </td>
                        <td className="type">Positive Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">rateIntervalRequests</td>
                        <td className="meaning">Request limit. This is the maximum number of requests your account can make each time window.
                        </td>
                        <td className="type">Positive Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">rateIntervalSeconds</td>
                        <td className="meaning">Number of seconds in the time window.
                        </td>
                        <td className="type">Positive Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">permissions</td>
                        <td className="meaning">Object containing the resource permissions for the user.
                        </td>
                        <td className="type">See <a href="#uiv1_perm_object">permissions object</a> description</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-4" id="uiv1_perm_object">Permissions object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">endpoints</td>
                        <td className="meaning">A list of API endpoints the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available endpoints:<br/>
                            <br/>
                            {urlHandler.API_ENDPOINT_V1_DOC_SENTIMENT}<br/>
                            {urlHandler.API_ENDPOINT_V2_TAG}<br/>
                            {urlHandler.API_ENDPOINT_V1_USERINFO}<br/>
                            {urlHandler.API_ENDPOINT_V1_LOCATION_FINDER}<br/>
                            {urlHandler.API_ENDPOINT_V1_QUERY_PARSER}<br/>
                            {urlHandler.API_ENDPOINT_V1_DETECT_LANGUAGE}<br/>
                            {urlHandler.API_ENDPOINT_V1_DETECT_LANGUAGES}<br/>
                            {urlHandler.API_ENDPOINT_V1_CORRECT_TEXT}<br/>
                            {urlHandler.API_ENDPOINT_V1_SUMMARIZE}<br/>
                            {urlHandler.API_ENDPOINT_V1_CONVERT_DOC}<br/>
                            {urlHandler.API_ENDPOINT_V2_CONVERT_DOC}<br/>
                            {urlHandler.API_ENDPOINT_V1_IE_PROMPTS}<br/>
                            {urlHandler.API_ENDPOINT_V2_ENRICH}<br/>
                            {urlHandler.API_ENDPOINT_V2_ENTITIES}<br/>
                            ...
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">entities</td>
                        <td className="meaning">A list of entities the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">See available <Link to="/documentation/doc_v2enrich#enrichv2_entity_types" className="list-link">entities</Link>.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">features</td>
                        <td className="meaning">A list of features the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available features:<br/>
                            <br/>
                            TopicVector<br/>
                            Disambiguation<br/>
                            DocumentSentiment<br/>
                            EntitySentiment<br/>
                            KeyPhrases<br/>
                            Usage<br/>
                            Tags<br/>
                            EntityCreate<br/>
			                EntityDelete<br/>
			                EntityRead<br/>
		                    EntityUpdate<br/>
                            EntitySearch<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">language</td>
                        <td className="meaning">A list of languages the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available languages:<br/>
                            <br/>
                            en<br/>
                            ru<br/>
                            ar<br/>
                            es<br/>
                            fr<br/>
                            nl<br/>
                            uk<br/>
                            de<br/>
                            zh<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">sentimentModels</td>
                        <td className="meaning">A list of sentiment models the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available models:<br/>
                            <br/>
                            news3<br/>
                            earningsCall<br/>
                            financial3<br/>
                            financialTopics<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">summaryModels</td>
                        <td className="meaning">A list of summary models the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available models:<br/>
                            <br/>
                            News<br/>
                            News-Base<br/>
                            News-Eval<br/>
                            TextRank<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">salienceModels</td>
                        <td className="meaning">A list of salience models the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available models:<br/>
                            <br/>
                            News<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">topicModels</td>
                        <td className="meaning">A list of topic models the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available models:<br/>
                            <br/>
                            news<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">taggingModels</td>
                        <td className="meaning">A list of tagging models the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available models:<br/>
                            <br/>
                            {/* dau<br/>
                            dau-2<br/>
                            currentNews<br/>
                            companyDescriptions<br/>
                            naics<br/>
                            esg<br/> */}
                            iptc<br/>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">translationLanguages</td>
                        <td className="meaning">A list of translation language pairs in format <i>src</i>-<i>dest</i> the user is authorized for.</td>
                        <td className="type">List of Strings</td>
                        <td className="notes">Available language pairs:<br/>
                            <br/>
                            ar-en<br/>
                            de-en<br/>
                            en-uk<br/>
                            es-en<br/>
                            fr-en<br/>
                            nl-en<br/>
                            ru-en<br/>
                            uk-en<br/>
                            zh-en
                        </td>
                    </tr>

                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_USERINFO}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                    </pre>
                </div>
                <HttpRunner query="userinfo" 
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_USERINFO) : null}
                />
            </div>
        );
    }
}

export default DocV1UserInfo;